module.exports = __webpack_public_path__ + "img/passeio-observacao.77096d0d.jpg";